/** Sum investment rows for a startup (client-side fallback). */
export const aggregatedInvestmentForStartup = (startupUserId, investments, networkLinkedStartupIds) => {
    const sid = Number(startupUserId);
    if (networkLinkedStartupIds != null) {
        const allowed =
            networkLinkedStartupIds instanceof Set
                ? networkLinkedStartupIds
                : new Set(networkLinkedStartupIds);
        if (!allowed.has(sid)) {
            return null;
        }
    }
    const rows = (investments || []).filter((i) => Number(i.startupId) === sid);
    if (!rows.length) return null;
    const total = rows.reduce((sum, i) => sum + (Number(i.investmentAmount) || 0), 0);
    const currency = rows.find((r) => r.currency)?.currency || 'INR';
    const status = rows.some((r) => r.status === 'ACTIVE') ? 'ACTIVE' : rows[0].status;
    const primary = rows.reduce(
        (best, r) => ((Number(r.investmentAmount) || 0) > (Number(best?.investmentAmount) || 0) ? r : best),
        rows[0],
    );
    return {
        ...primary,
        investmentAmount: total,
        currency,
        status,
        equityPercentage: rows.length === 1 ? primary.equityPercentage : undefined,
    };
};

/**
 * Prefer server-side totals (linked portfolio + network investors only).
 * @param {number|string} startupId
 * @param {Record<number, { totalAmount: number, currency: string }>} totalsByStartupId
 * @param {Array} investments
 * @param {number[]|Set<number>|null} networkLinkedStartupIds — if non-null, fallback only runs for these startup user ids
 */
export const portfolioInvestmentForCard = (
    startupId,
    totalsByStartupId,
    investments,
    networkLinkedStartupIds = null,
) => {
    const sid = Number(startupId);
    const t = totalsByStartupId?.[sid];
    if (t != null && t.totalAmount != null && !Number.isNaN(Number(t.totalAmount))) {
        return {
            investmentAmount: Number(t.totalAmount),
            currency: t.currency || 'INR',
            status: 'ACTIVE',
        };
    }
    return aggregatedInvestmentForStartup(sid, investments, networkLinkedStartupIds);
};
